<template>
  <div id="mediaManager">

    <Datatable
      entity="branch_image"
      ref="datatable"
      contain
      :onRowClick="onRowClick"
      :parameters="{branch: $route.query.branch}"
      :globalActions="[
        {text: 'media_manager.new_image', method: newImage},
        {text: 'media_manager.new_video', method: newVideo},
        {text: 'media_manager.new_document', method: newDocument},
        {text: 'media_manager.new_bucket_file', method: newBucketFile}]"
      :rowActions="[
        {text: 'datatable.display', method: onRowClick},
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete}
      ]"
    />

    <Modal name="uploadImage" class="modalUpload"
           :title="$t('media_manager.new_image')"
           :actions="[{name: $t('back'), action: 'close'}, {name: $t('media_manager.upload'), action: uploadImage, primary: true}]">
      <div class="group">
        <label>{{$t('file_name')}}</label>
        <input type="text" v-model="imageAsset.name">
      </div>
      <ImageUpload identifier="imageUploadNewAsset" @changed="imageAsset = $event"></ImageUpload>
    </Modal>


    <Modal name="uploadBucketFile" class="modalUpload"
           :title="$t('media_manager.new_bucket_file')"
           :actions="[{name: $t('back'), action: 'close'}, {name: $t('media_manager.upload'), action: uploadBucketFile, primary: true}]">
      <div class="description" v-html="$t('media_manager.upload_from_bucket').replace('{URL}', Parameters.urlFileServer)"></div>
      <br>
      <div class="group">
        <label>{{$t('file_name')}}</label>
        <input type="text" v-model="bucketFile.name">
      </div>
      <div class="group">
        <label>{{$t('media_manager.bucket_file_URL')}}</label>
        <input type="text" v-model="bucketFile.url">
      </div>
    </Modal>

    <Modal name="uploadDocument" class="modalUpload"
           :title="$t('media_manager.new_document')"
           :actions="[{name: $t('back'), action: 'close'}, {name: $t('media_manager.upload'), action: uploadDocument, primary: true}]">
      <div class="group">
        <label>{{$t('file_name')}}</label>
        <input type="text" v-model="documentAsset.name">
      </div>
      <ImageUpload document identifier="documentUploadNewAsset" @changed="documentAsset = $event"></ImageUpload>
    </Modal>

    <Modal name="uploadVideo" class="modalUpload"
           :title="$t('media_manager.new_video')"
           :actions="[{name: $t('back'), action: 'close'}, {name: $t('media_manager.upload'), action: uploadVideo, primary: true}]">
      <div class="group">
        <label>{{$t('file_name')}}</label>
        <input type="text" v-model="videoAsset.name">
      </div>
      <ImageUpload video identifier="videoUploadNewAsset" @changed="videoAsset = $event"></ImageUpload>
    </Modal>

    <Modal name="editFile" class="modalEdit" v-if="editFile"
           :title="$t('media_manager.edit_file')"
           :actions="[{name: $t('back'), action: 'close'}, {name: $t('save'), action: saveFile, primary: true}]">
      <div class="group">
        <label>{{$t('file_name')}}</label>
        <input type="text" v-model="editFile.name">
      </div>
    </Modal>

  </div>
</template>

<script>
  import Datatable from "@/components/Datatable.vue";
  import ImageUpload from "@/components/tools/ImageUpload.vue";
  import { mapActions } from 'vuex';
  import { Core } from "@/core/Core";

  export default {
    name: "mediaManager",

    components: { Datatable, ImageUpload },

    data() {
      return {
        imageAsset: { url: "", name: "" },
        documentAsset: { url: "", name: "" },
        videoAsset: { url: "", name: "" },
        bucketFile: { name: "", type: "", url: "" },
        mimeTypes: {
          "jpeg": "image/jpeg",
          "jpg": "image/jpeg",
          "png": "image/png",
          "gif": "image/gif",
          "mp4": "video/mp4"
        },
        Parameters,
        editFile: null
      }
    },

    computed: {
      branchId() {
        return this.$route.query.branch;
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "media_manager.title";
      this.$store.state.pageIcon = "icon/picture.svg";
    },

    methods: {
      ...mapActions(["getBranchImage", "postBranchImage", "putBranchImage", "deleteBranchImage"]),

      newImage() {
        this.$modal.show("uploadImage");
      },
      newVideo() {
        this.$modal.show("uploadVideo");
      },
      newBucketFile() {
        this.$modal.show("uploadBucketFile");
      },
      newDocument() {
        this.$modal.show("uploadDocument");
      },
      async uploadImage() {
        this.upload(this.imageAsset, "uploadImage");
      },
      uploadDocument() {
        this.upload(this.documentAsset, "uploadDocument");
      },
      uploadVideo() {
        this.upload(this.videoAsset, "uploadVideo");
      },
      async uploadBucketFile() {
        if (!this.bucketFile.url) {
          return;
        }
        //Validate bucket URL
        if (this.bucketFile.url.indexOf(Parameters.urlFileServer) !== 0) {
          showAffirmation(this.$t("warning"),this.$t('media_manager.invalid_bucket_url').replace("{URL}", Parameters.urlFileServer));
          return;
        }
        //Validate file extension format
        let urlParts = this.bucketFile.url.split(".");
        let extension = urlParts[urlParts.length - 1];
        if (!this.mimeTypes[extension]) {
          showAffirmation(this.$t("warning"),this.$t('media_manager.bucket_file_type_invalid'));
          return;
        }
        //Parse data for save
        let data = JSON.parse(JSON.stringify(this.bucketFile));
        data.type = this.mimeTypes[extension];
        data.url = data.url.replace(Parameters.urlFileServer, "");
        data.branch = parseInt(this.branchId);

        //Upload data
        showSpinner();
        let response = await this.postBranchImage({data});
        hideSpinner();
        if (response) {
          this.$modal.hide("uploadBucketFile");
          this.bucketFile = { url: "", type: "", name: "" };
          this.$refs.datatable.query();
          toast(this.$t("media_manager.save_success"), "success", this.$t('success'));
        } else {
          toast(this.$t("error.no_server"), "error");
        }
       },
      async upload(asset, modalName) {
        if (!asset.url) {
          return;
        }
        let data = {
          branch: parseInt(this.branchId),
          image: asset.base64,
          name: asset.name,
        };
        //Upload data
        showSpinner();
        let response = await this.postBranchImage({data});
        hideSpinner();
        if (response) {
          this.$modal.show(modalName);
          this.$refs.datatable.query();
          this.videoAsset = { url: "", name: "" };
          this.documentAsset = { url: "", name: "" };
          this.imageAsset = { url: "", name: "" };
          toast(this.$t("media_manager.save_success"), "success", this.$t('success'));
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      },
      onRowClick(row) {
        window.open(row.image, '_blank').focus();
      },
      onRowEdit(row) {
        this.editFile = JSON.parse(JSON.stringify(row));
        this.$nextTick(() => {
          this.$modal.show("editFile");
        });
      },
      async saveFile() {
        if (!this.editFile) {
          return;
        }
        let data = {
          name: this.editFile.name
        };
        showSpinner();
        let response = await this.putBranchImage({imageId: this.editFile.id, data: data});
        hideSpinner();
        if (response) {
          this.$modal.show("editFile");
          this.$refs.datatable.query();
          toast(this.$t("media_manager.save_success"), "success", this.$t('success'));
          this.$nextTick(() => {
            this.editFile = null;
          });
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      },
      async onRowDelete(row) {
        let response = await showConfirmation(this.$t('warning'), this.$t('media_manager.delete').replace("{NAME}", row.name));
        if (response) {
          showSpinner();
          let response = await this.deleteBranchImage({imageId: row.id});
          hideSpinner();
          if (response) {
            this.$refs.datatable.query();
            toast(this.$t("media_manager.delete_success"), "success", this.$t('success'));
          } else {
            toast(this.$t("error.no_server"), "error");
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  #mediaManager {
    .modalUpload .modalContainer {
      width: 750px;
    }
  }
</style>
